<template>
    <div class="guest layout">
        <v-loader/>
        <router-view></router-view>
        <v-icon-sprites />
    </div>
</template>

<script>
    import '@/style/main.css';
    import {vIconSprites} from '@/components/form';
    import vLoader from '@/components/v-loader';
    import StateIdentifiers from '@/plugins/load-state/state-identifiers';

    export default {
        components: {vIconSprites, vLoader},
        computed: {
            isReady() {
                return !this.$store.getters['loading/isLoading'](StateIdentifiers.application);
            },
        },
        data() {
            return {};
        },
    };
</script>
